<script  lang="ts">
    import { service } from "@frontend/services";
    import { GetCachedToken, me } from "@frontend/user";
    import { AddGroupRequest, AddPlayGroupRequest, ApiResultOfPlayGroupDTO, AuthenticatedRequestOfAddGroupRequest, type ApiResultOfGroupDTO } from "@frontend/walletapi";
    import { groups } from "@frontend/grouplist";
  import { push } from "svelte-spa-router";
  import { translate, currentLanguage } from "../Translator";
    

  export let dismiss: () => void; 


    let emptyGroup: AddPlayGroupRequest = {
        Label: "",
        GroupName: ""
    };
    
    let newGroup: AddPlayGroupRequest = {...emptyGroup};
    
    let result: ApiResultOfPlayGroupDTO | undefined = undefined;


   

    async function AddPlayGroup() {
        result = await service.walletapi.addPlayGroup({
            Token: GetCachedToken(),
            Data: newGroup,
        });

        if (result.Success) {
            setTimeout(() => push("#/Groups"), 2000);
        }
    }
</script>

<h2 class="ui centered dividing header">{$translate ('New Play Groups')}</h2>
{#if result && result.Success && result.Data}
    <div class="ui positive message">
        <div class="header">
            {$translate ('Play Group added successfully')}
        </div>

      
    </div>

    <div class="ui segment" style="display: flex;">
        <table class="receit-table" style="flex-grow: 1;">
            <tr>
                <td class="receit-title">{$translate ('Id')}</td>
                <td class="receit-value">#{result.Data.Id}</td>
            </tr>
            <tr>
                <td class="receit-title">{$translate ('Label')}</td>
                <td class="receit-value">{result.Data.Label}</td>
            </tr>
            <tr>
                <td class="receit-title">{$translate ('Group Name')}</td>
                <td class="receit-value">{result.Data.GroupName ?? "None"}</td>
            </tr>
        </table>
    </div>
    <div class="button-container">
        <button class="ui primary fluid button" on:click={dismiss}>{$translate ('Dismiss')}</button>
    </div>
{:else}
    {#if result && !result.Success}
        <div class="ui negative message">
            <div class="header">Error</div>
            <p>{result.ErrorMessage ?? "Unknown error when adding group"}</p>
        </div>
    {/if}


    <form class="ui form" on:submit|preventDefault={AddPlayGroup}>
        <div class="field">
            <label>{$translate ('Label')}</label>
            <input type="text" bind:value={newGroup.Label} placeholder="Label" required>
        </div>
        <div class="field">
            <label>{$translate ('Group Name')}</label>
            <input type="text" bind:value={newGroup.GroupName} placeholder="Group Name" required>
        </div>


        <div class="ui buttons">
            <button class="ui button" type="button"  on:click={dismiss}>{$translate ('Cancel')}</button>
            <div class="or"></div>
            <button class="ui positive button" type="submit">{$translate ('Add play Group')}</button>
        </div>
    </form>
{/if}

<style>
    .receit-table {
        width: 100%;
        border-collapse: collapse;
    }
    .receit-title {
        font-weight: bold;
        padding: 8px;
        border-bottom: 1px solid #ddd;
    }
    .receit-value {
        padding: 8px;
        border-bottom: 1px solid #ddd;
    }
</style>
